export const name = 'deposit';

export const Deposit = () => (
  <svg
    viewBox="0 0 24 25"
    fill="none"
    color="#161619"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 3.5L12 16.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="bevel"
    />
    <path
      d="M6.96777 8.53247L12.0003 3.49997L17.0328 8.53247"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <line
      x1="4"
      y1="20.75"
      x2="20"
      y2="20.75"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);
